module.exports = __webpack_public_path__ + "static/media/sonar.5890d33.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/sonar.mp3
// module id = DuVK
// module chunks = 1